<template>
  <div class="config-form-box">
    <el-form
      ref="ConfigForm"
      :model="formConfig"
      :inline="true"
      :label-width="labelWidth"
      @submit.native.prevent
      class="configForm"
    >
      <el-form-item
        v-show="!item.hide"
        v-for="(item, key) in formConfig"
        :key="key"
        :label="item.label"
        :label-width="item.label ? item.labelWidth : '0px'"
        :prop="[key]+'[value]'"
      >
        <span v-if="item.type === 'text'">
          <span v-if="item.formatter">{{item.formatter(item.value)}}</span>
          <span v-else v-html="item.value"></span>
          <!-- {{ item.formatter ? item.formatter(item.value) : i }} -->
        </span>

        <component v-if="item.type === 'component'" :is="item.value" />

        <el-input
          class="input"
          :style="{width: item.width + 'px', }"
          v-else-if="item.type === 'input'"
          v-model="item.value"
          clearable
          :placeholder="item.placeholder || `请输入${item.label}`"
          @keyup.enter.native="getData"
          @change="onItemChange(item)"
        >
          <i v-if="item.addSearch" slot="suffix" class="iconhuice icon-a-16 icon-search" @click="onItemChange(item)"></i>

        </el-input>

        <NumInput
          v-else-if="item.type === 'num'"
          v-model="item.value"
          :min="item.min"

          clearable
          :placeholder="item.placeholder || `请输入${item.label}`"
          @keyup.enter.native="getData"
          @change="onItemChange(item)"
        />

        <el-select
          :style="{width: item.width + 'px', }"
          v-else-if="item.type === 'select'"
          v-model="item.value"
          :multiple="Array.isArray(item.value)"
          filterable
          :clearable="!item.noCleara"
          :placeholder="item.placeholder || `请选择`"
          :disabled="item.disabled||false"
          collapse-tags
          @change="onItemChange(item)"
        >
          <el-option
            v-for="it in item.options"
              :key="it.key?it.key:it.id!== undefined ? it.id : it.value"
            :label="it.name!== undefined ? it.name : it.label"
            :value="it.id !== undefined ? it.id : it.value"
          />
        </el-select>

        <MultipleSelect v-else-if="item.type === 'select-plus'" ref="MultipleSelect" :config="item" @change="onItemChange" />

        <MultipleTreeSelect v-else-if="item.type === 'select-tree-plus'" ref="MultipleTreeSelect" :config="item" @change="onItemChange" />

        <el-switch
          v-else-if="item.type === 'switch'"
          v-model="item.value"
          :active-value="item.options.trueValue"
          :inactive-value="item.options.falseValue"
          @change="onItemChange(item)" />

        <DatePickerCustom style="width: 220px" v-else-if="item.type === 'daterange'" :config="item" @handleDateChange="onItemChange" />
        <DatePickerMonth style="width: 220px" v-else-if="item.type === 'month-daterange'" :config="item" @handleDateChange="onItemChange" />

        <DateTimeRange v-else-if="item.type ==='date-time-range'" v-model="item.value" />
        <MaxMinInput v-else-if="item.type === 'numrange'" v-model="item.value" :precision="item.precision" />

        <el-cascader
          v-else-if="item.type === 'cascader'"
          v-model="item.value"
          :placeholder="item.placeholder || `请选择`"
          :show-all-levels="false"
          :options="item.options"
          clearable
          :props="{ multiple: false, checkStrictly: true,expandTrigger: 'hover', value: 'id', label: 'name', children: 'children' }"
          @change="onItemChange(item)"
        />

        <el-input
          v-else-if="item.type === 'selectinput'"
          v-model="item.inputValue"
          class="selectinput"
          clearable
          :placeholder="item.placeholder || `请输入${item.label?item.label:''}`"
          @keyup.enter.native="getData"
          @clear="getData"
        >
          <el-select
            v-outFocus
            slot="prepend"
            v-model="item.selectValue"
            :style="{minWidth: item.label ? '80px': item.width || '100px', padding: 0}"
            @change="selectinputChange(item)"
          >
            <el-option
              v-for="it in item.options"
              :key="it.id !== undefined ? it.id : it.value"
              :value="it.id !== undefined ? it.id : it.value"
              :label="it.name !== undefined ? it.name : it.label"
            />
          </el-select>
          <i v-if="noShowSearch" slot="suffix" class="iconhuice icon-a-16 icon-search" @click="onItemChange(item)"></i>
        </el-input>

        <el-input
          v-else-if="item.type === 'textarea'"
          v-model="item.value"
          class="config-text-area"
          type="textarea"
          :rows="1"
          :placeholder="item.placeholder || `以“回车”或“；”分隔，最多输入50条数据`"
          @keyup.enter.native="getData"
          @change="onItemChange(item)"
        />

        <RadioButton
          v-else-if="item.type === 'radio-button'"
          :config="item"
          @change="onItemChange(item, item.value)"
        />

        <div class="selectDatePicker" v-else-if="item.type === 'selectDatePicker'">
          <el-select
            v-if="!item.label"
            v-outFocus
            v-model="item.selectValue"
            :style="{width: item.width ||'100px', padding: 0}"
            @change="onItemChange(item)"
          >
            <el-option
              v-for="it in item.options"
              :key="it.id !== undefined ? it.id : it.value"
              :value="it.id !== undefined ? it.id : it.value"
              :label="it.name !== undefined ? it.name : it.label"
            />
          </el-select>
          <DatePickerCustom style="margin-left: -3px;width: 220px" :config="item" @handleDateChange="onItemChange" />
        </div>

      </el-form-item>
      <el-form-item
        v-if="$slots.default"
        style="float: right;"
      >
        <slot />
      </el-form-item>

      <!-- 重置搜索按钮 -->
      <el-form-item>
        <div>
          <el-button
            v-if="!noShowReset"
            v-outFocus
            class="form__button__reset"
            @click="getResetData()"
          >
            <!-- <i> <svg-icon icon-class="reset-1" class="icon-margin icon-news" /></i> -->
            重置
          </el-button>
          <el-button
            v-if="!noShowSearch"
            v-outFocus
            class="btn-wrap main-btn"
            @click="getData()"
          >
            <i> <svg-icon icon-class="search-news" class="icon-margin icon-news" /></i>
            搜索
          </el-button>
        </div>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import MaxMinInput from '@/components/max-min-input'
import DateTimeRange from '@/components/date-time-range/index.vue'
import NumInput from '@/components/auth-num-input/index.vue'
import MultipleSelect from '@/components/multiple-select'
import MultipleTreeSelect from '@/components/multiple-tree-select'
import DatePickerCustom from '@/components/date-picker-custom/index.vue'
import DatePickerMonth from '@/components/date-picker-month/index.vue'
import RadioButton from '@/components/radio-button/index.vue'

import { deepCopy } from '@/utils/deep-copy'
export default {
  name: 'ConfigForm',
  components: {
    MaxMinInput,
    DateTimeRange,
    NumInput,
    MultipleSelect,
    MultipleTreeSelect,
    DatePickerCustom,
    RadioButton,
    DatePickerMonth
  },
  props: {
    formConfig: {
      type: Object,
      required: true
    },
    labelWidth: {
      type: String,
      default: '85px'
    },
    noShowReset: {
      type: Boolean,
      default: false
    },
    noShowSearch: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    getResetData() {
      // 重置表单数据
      this.resetFormData()

      this.$emit('resetFuc')
    },
    getData() {
      this.$emit('searchFuc')
    },
    resetFormData() {
      const { formConfig } = this
      Object.values(formConfig).forEach(row => {
        // eslint-disable-next-line no-prototype-builtins
        if (row.hasOwnProperty('defaultValue')) {
          row.value = deepCopy(row.defaultValue)
        }
        // eslint-disable-next-line no-prototype-builtins
        if (row.hasOwnProperty('defaultInputValue')) {
          row.inputValue = deepCopy(row.defaultInputValue)
        }
        // eslint-disable-next-line no-prototype-builtins
        if (row.hasOwnProperty('defaultSelectValue')) {
          row.selectValue = deepCopy(row.defaultSelectValue)
        }
      })
    },
    async onItemChange(item) {
      if (item.onChange && item.updateTable) { // 执行自身方法也更新表格
        await item.onChange()
        this.getData()
      } else if (item.onChange) {
        item.onChange()
      } else if (this.noShowSearch) {
        this.getData()
      }
    },
    selectinputChange(item) {
      if (item.inputValue) {
        this.onItemChange(item)
      }
    },
    hideHack() { // 隐藏body下的模拟select hack曲线救国
      const refs = ['MultipleSelect', 'MultipleTreeSelect']
      refs.forEach(ref => {
        if (this.$refs[ref]) {
          this.$refs[ref].forEach(item => {
            item.isShow = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.config-form-box{
  display: flex;
  background: #ffffff;
  padding: 16px 16px 3px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.batch-search {
  padding: 12px 16px;
  background: #F6F6F6;
  border-radius: 4px;
  margin-bottom: 18px;
  .radio-wrap {
    display: flex;
    > span {
      white-space: nowrap;
      line-height: normal;
    }
    .el-radio {
      margin-right: 16px;
      height: 14px;
      line-height: 14px;
      margin-bottom: 8px;
      ::v-deep .el-radio__label {
        font-size: 12px;
        padding-left: 8px;
      }
    }
  }
}

.title {
  font-size: 12px;
  font-weight: 600;
  color: $main-color;
  margin-top: 6px;
  .el-divider {
    margin: 4px 0 24px;
  }
}
.input{
  ::v-deep .el-input__inner {
    border-radius: 2px !important;
    padding: 0 30px 0 20px;
  }
}
.selectinput {
  position: relative;
  width: 250px;
  ::v-deep .el-input__inner {
    border-radius: 0 2px 2px 0 !important;
    padding: 0 30px 0 20px;
  }
  ::v-deep .el-input-group__prepend {
    background-color: #FFFFFF;
    border-radius: 2px 0 0 2px;
    padding: 0 12px;
  }
  ::v-deep .el-input__suffix{
    margin-right: 20px;
  }
  ::v-deep .el-select .el-input__suffix{
    margin-right: 5px;
  }
  .icon-search{
    position: absolute;
    right: -15px;
    line-height: 32px;
    font-size: 13px;
  }
}

.el-form-item--small.el-form-item {
  margin-right: 12px;
  margin-bottom: 12px;
}

.el-form-item--small ::v-deep .el-form-item__content {
  min-height: 33px;
}

.el-range-editor.el-input__inner {
  width: 100%;
}

// 多选 tag长度限制，因为有name 有+3 有输入，暂时设置43%
.el-select ::v-deep .el-tag {
  max-width: 43%;
  overflow: hidden;
  text-overflow: ellipsis;
}

// textarea
.config-text-area ::v-deep textarea {
  min-height: 32px!important;
  border-radius: 2px;
}

// 更改北京组件原始样式
.configForm{
  flex: 1;
}
.configForm ::v-deep .el-form-item--small .el-form-item__label {
  height: 32px;
  line-height: 32px;
  // border: solid 1px $G5;
  // border-right-width: 0;
  // border-radius: 2px;
  // 垂直对齐方案，后面再研究
  // position: relative;
  // top: -2px;
}
.configForm ::v-deep .el-range-editor--small.el-input__inner {
  height: 32px;
  line-height: 32px;
}
.configForm ::v-deep .el-input--small .el-input__inner {
  height: 32px;
  line-height: 32px;
}
.selectDatePicker{
  display: flex;
  align-items: center;;
  ::v-deep .el-select .el-input.is-focus .el-input__inner{
    border-color: #C0C4CC
  }
  ::v-deep .el-select .el-input__inner:focus{
    border-color: #C0C4CC
  }
}
.btn-wrap.el-button{//右侧搜索主按钮
  height:32px;
  width: 88px;
  font-size: 13px;
  padding-left: 23px;
  padding-right:23px;
  .icon-margin{
    margin-right:0px;
    &:hover{
      color:inherit;
    }
    &:active{
      color:inherit;
    }
  }
  &.main-btn{
    background: $main-color;
    border-radius: 2px;
    color:#fff;
    border:1px solid $main-color;
    margin-left:10px;
    .icon-a-16{
      font-size:12px;
    }
    &:hover{
      background: $main-hover-color;
      color:#fff;
      border-color:$main-hover-color ;
    }
    &:active{
      background: $main-focus-color;
      color:#fff;
      border-color: $main-focus-color;

    }
  }
  &.second-btn{
    width: 32px;
    font-size: 13px;
    padding: 0;
    color:#606266;
    background: linear-gradient(180deg, #FCFCFC 0%, #F6F6F6 100%);
    &:hover{
      background-color: transparent;
      border-color:$main-hover-color;
      color:$main-hover-color
    }
    &:active{
      background-color: transparent;
      color:$main-focus-color;
      border-color:$main-color;
    }
  }
}

.form__button__reset {
  background-color: #F6F6F6;
  &:hover {
    background-color: #EFF6FD;
  }
}

::v-deep .el-form-item__label {
  border-top: 1px solid $G4;
  border-bottom: 1px solid $G4;
  border-left: 1px solid $G4;
  border-radius: 2px 0 0 2px;
}
</style>
